var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"menu-toggle",class:{open: _vm.isOpen},attrs:{"href":"#"},on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"navicon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }